// Växlar visningen av minicart (öppna/stäng)
export function toggleMiniCart() {
    const miniCartWrapper = document.querySelector('#mini-cart-dropdown').parentElement

    if (document.body.classList.contains('mini-cart-open')) {
        miniCartWrapper.classList.remove('active')
        document.body.classList.remove('mini-cart-open')
    } else {
        miniCartWrapper.classList.add('active')
        document.body.classList.add('mini-cart-open')
    }
}

document.addEventListener('click', function (e) {
    if (e.target.closest('.cart-toggle-btn')) {
        toggleMiniCart()
    }
})

// Läser ut ett enskilt värde ur document.cookie.
function lwCookieValue(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'))
    return match ? decodeURIComponent(match[1]) : ''
}

function lwWcAjaxUrl(endpoint) {
    const tpl = window.wc_add_to_cart_params?.wc_ajax_url || '/?wc-ajax=%%endpoint%%'
    return tpl.replace('%%endpoint%%', endpoint)
}

jQuery(function ($) {
    // Var felrutan för ett misslyckat köp ska hamna: sist i produktformuläret
    // (enskild produkt) respektive i loop-wrappern — alltid i anslutning till
    // knappen man just tryckte på.
    function addToCartErrorHost(button) {
        var $host = button.closest('form.cart')
        if (!$host.length) $host = button.closest('.lw-loop-add-to-cart')
        if (!$host.length) $host = button.parent()
        return $host
    }

    function clearAddToCartError(button) {
        addToCartErrorHost(button).find('.lw-atc-error').remove()
    }

    function showAddToCartError(button, html) {
        clearAddToCartError(button)
        $('<div class="lw-atc-error"></div>').html(html).appendTo(addToCartErrorHost(button))
    }

    function refreshMiniCart() {
        $.ajax({
            url: lwWcAjaxUrl('get_refreshed_fragments'),
            type: 'POST',
            beforeSend: function () {
                $(document.body).trigger('wc_fragment_refresh')
            },
            success: function (data) {
                if (!data.fragments) return

                $.each(data.fragments, function (selector, html) {
                    $(selector).html(html)
                })

                var hasItems = data.fragments.total_count > 0

                $('.checkout-button').toggleClass('disabled', !hasItems)
                $('#lw-share-cart-btn').toggleClass('hidden', !hasItems)

                // Containern bär serverns varukorgshash från sidladdningen.
                // Skriv om den till det som nu ligger i sessionen, annars tror
                // en senare kontroll att markupen fortfarande är inaktuell.
                $('#mini-cart-dropdown').attr('data-cart-hash', hasItems ? data.cart_hash || '' : '')

                $(document.body).trigger('wc_fragments_refreshed', [data.fragments])
                $(document.body).trigger('wc_fragments_loaded', [data.fragments])
                $(document.body).trigger('cart_totals_refreshed')
            },
            error: function () {
                $(document.body).trigger('wc_fragments_ajax_error')
            },
        })
    }

    $(document).on('click', '.single_add_to_cart_button, .product_type_simple.add_to_cart_button', function (e) {
        e.preventDefault()
        e.stopImmediatePropagation()

        var $form = $(this).closest('form.cart')
        var button = $(this)

        // Handlern kapar klicket med stopImmediatePropagation, så WC:s egna
        // spärrar hinner aldrig säga ifrån. Respektera därför disabled-läget
        // själva — annars skickas ett köp som servern ändå avvisar.
        //
        // Enbart propertyn, INTE .disabled-klassen: WC låter klassen ligga kvar
        // på knappen även när en giltig variant är vald, så en klasskontroll
        // hade blockerat helt legitima köp. Propertyn för en ej köpbar variant
        // (slut i lager) sätts i out-of-stock.js.
        if (button.prop('disabled')) {
            return
        }

        var formData = $form.length ? new FormData($form[0]) : new FormData()

        // Variabel produkt utan vald variant: servern kan inte lägga något i
        // varukorgen, den skulle bara lägga en "Välj produktalternativ"-notis i
        // sessionen som dyker upp på nästa sidvisning (typiskt kassan). Skicka
        // inget — WC:s egen variantvalidering visar återkopplingen på plats.
        if ($form.length && $form.hasClass('variations_form') && !parseInt(formData.get('variation_id'), 10)) {
            return
        }

        // Build payload from wrapper + selected variation
        if (!$form.length) {
            var $wrap = button.closest('.lw-loop-add-to-cart')
            if ($wrap.length) {
                var productId = $wrap.data('product-id')
                var variationId = $wrap.attr('data-selected-variation-id')
                var attrsJson = $wrap.attr('data-selected-attrs') || '{}'

                if (!productId || !variationId) {
                    // no selected variation -> do nothing
                    return
                }

                formData.set('product_id', productId)
                formData.set('variation_id', variationId)
                formData.set('quantity', '1')

                // also send add-to-cart (some setups like it)
                formData.set('add-to-cart', productId)

                try {
                    var attrs = JSON.parse(attrsJson)
                    Object.keys(attrs || {}).forEach(function (k) {
                        formData.set(k, attrs[k])
                    })
                } catch (err) {
                    // ignore JSON-fel
                }
            }
        }

        // Befintlig fallback: om simple saknar add-to-cart/product_id
        if (!formData.get('product_id') && !formData.get('add-to-cart')) {
            var productId =
                button.val() ||
                button.data('product_id') ||
                button.attr('data-product_id') ||
                $form.find('input[name="add-to-cart"]').val()
            if (productId) {
                formData.set('add-to-cart', productId)
            }
        }

        if (!button.hasClass('cs_add_to_cart_button')) {
            button.text(liGlobal.addingToCartText)
        }

        clearAddToCartError(button)

        $(document.body).trigger('adding_to_cart', [button, formData])

        // OBS: endpointen är get_refreshed_fragments, INTE add_to_cart.
        //
        // WC_AJAX::add_to_cart() anropar WC()->cart->add_to_cart($product_id, $qty)
        // utan variation_id och klarar därför bara enkla produkter. För en variant
        // kastade den "Välj produktalternativ genom att besöka …" som en
        // error-notis i sessionen — den dök sedan upp på nästa sidvisning, typiskt
        // kassan, trots att varianten låg korrekt i varukorgen.
        //
        // Att den ändå hamnade rätt beror på att payloaden innehåller
        // `add-to-cart`, vilket får WC_Form_Handler::add_to_cart_action() att köra
        // på wp_loaded — den hanterar variation_id och attribut korrekt. Det är
        // alltså den vägen som gör jobbet, och add_to_cart-endpointen lade bara
        // till ett andra, dömt försök.
        //
        // Med get_refreshed_fragments körs formulärhanteraren på wp_loaded och
        // fragmenten byggs efteråt på template_redirect — samma svarsformat
        // ({fragments, cart_hash}) som success-callbacken redan förväntar sig.
        $.ajax({
            url: lwWcAjaxUrl('get_refreshed_fragments'),
            method: 'POST',
            data: formData,
            contentType: false,
            processData: false,

            success: function (data) {
                var fragments = data && data.fragments ? data.fragments : null
                var cartHash = data && data.cart_hash ? data.cart_hash : null

                // Misslyckat köp (slut i lager, ej köpbar variant, plugin-
                // validering): felen kommer med i svaret i stället för att ligga
                // kvar i sessionen och dyka upp på nästa sidvisning — se
                // includes/woocommerce/action-functions/minicart/lw_minicart_add_to_cart_notices.php.
                // Visa dem vid knappen och låt bli att öppna minivarukorgen, som
                // annars glider upp som om något hade lagts till.
                var errorHtml = fragments ? fragments.lw_atc_notices : ''
                if (errorHtml) {
                    showAddToCartError(button, errorHtml)
                    if (!button.hasClass('cs_add_to_cart_button')) {
                        button.text(liGlobal.addToCartText)
                    }
                    $(document.body).trigger('wc_add_to_cart_error', [button])
                    return
                }

                $(document.body).trigger('added_to_cart', [fragments, cartHash, button])
                $(document.body).trigger('wc_cart_button_updated', [button])

                refreshMiniCart()

                setTimeout(() => {
                    toggleMiniCart()
                    if (!button.hasClass('cs_add_to_cart_button')) {
                        button.text(liGlobal.addToCartText)
                    }
                }, 500)
            },

            error: function () {
                $(document.body).trigger('wc_add_to_cart_error', [button])
                if (!button.hasClass('cs_add_to_cart_button')) {
                    button.text(liGlobal.addToCartText)
                }
            },
        })
    })

    // Cross-sells "Lägg till"-knapp för enkla produkter i mini-cart. Använder WC:s
    // add_to_cart wc-ajax-endpoint men avbryter event så den yttre <a> inte navigerar
    // och den generiska add-to-cart-handlern (som stänger mini-carten) inte triggar.
    // Vi refreshar bara fragmenten så mini-carten hålls öppen.
    $(document).on('click', '.lw-minicart-cross-sell-add', function (e) {
        e.preventDefault()
        e.stopImmediatePropagation()

        const btn = $(this)
        const productId = btn.data('product-id')
        if (!productId) return
        if (btn.prop('disabled')) return

        const originalText = btn.text()
        btn.prop('disabled', true)
        if (window.liGlobal?.addingToCartText) {
            btn.text(window.liGlobal.addingToCartText)
        }

        $.ajax({
            url: lwWcAjaxUrl('add_to_cart'),
            method: 'POST',
            data: {
                product_id: productId,
                quantity: 1,
            },
            success: function (data) {
                const fragments = data && data.fragments ? data.fragments : null
                const cartHash = data && data.cart_hash ? data.cart_hash : null
                $(document.body).trigger('added_to_cart', [fragments, cartHash, btn])
                refreshMiniCart()
            },
            complete: function () {
                btn.prop('disabled', false)
                btn.text(originalText)
            },
        })
    })

    // +/-
    $(document).on('click', '.qty-plus', function () {
        const input = $(this).siblings('.mini-qty')
        const newQty = parseInt(input.val(), 10) + 1
        input.val(newQty).trigger('change')
    })

    $(document).on('click', '.qty-minus', function () {
        const input = $(this).siblings('.mini-qty')
        const minQty = parseInt(input.data('min-qty'), 10) || 1
        const newQty = Math.max(minQty, parseInt(input.val(), 10) - 1)
        input.val(newQty).trigger('change')
    })

    $(document).on('change', '.mini-qty', function () {
        const key = $(this).data('cart-item-key')
        const qty = $(this).val()

        $.ajax({
            url: liGlobal.ajaxUrl,
            method: 'POST',
            data: {
                action: 'lw_update_mini_cart_qty',
                cart_item_key: key,
                quantity: qty,
            },
            beforeSend: function () {
                $(document.body).trigger('update_cart_totals')
            },
            success: function (resp) {
                if (resp && resp.success) {
                    refreshMiniCart()
                    $(document.body).trigger('updated_cart_totals')
                    $(document.body).trigger('cart_totals_refreshed')
                }
            },
        })
    })

    // Sidan kan levereras ur LiteSpeeds publika sidcache och bär då den
    // varukorg som gällde när kopian skapades. WooCommerce sätter cookien
    // woocommerce_cart_hash till samma värde som servern renderar i
    // data-cart-hash. Skiljer de sig är markupen inaktuell och fragmenten
    // hämtas om — är de lika görs inget anrop.
    function syncMiniCartFromSession() {
        const dropdown = document.getElementById('mini-cart-dropdown')
        if (!dropdown) return

        if (lwCookieValue('woocommerce_cart_hash') === (dropdown.getAttribute('data-cart-hash') || '')) {
            return
        }

        refreshMiniCart()
    }

    syncMiniCartFromSession()
})
